<script setup>
import channelsightWidget from './js/channelsight-widget.js';
import dataModel from './js/model.js';
import logoBar from './components/logoBar.vue';
import widget from './components/widget.vue';
import hero from './components/hero.vue';
import twoColInteractive from './components/twoColInteractive.vue';
import maininfo from './components/maininfo.vue';
import bubbles from './components/bubbles.vue';

//invoke the channelsight widget
channelsightWidget();

//grab URL parameter to determine experience
let params = new URLSearchParams(document.location.search);
let brandContextParam = params.get("brandContext");

//parse URL parameter ready to pass to component
var brandContext = (!brandContextParam == '' && brandContextParam <= Object.keys(dataModel).length) ? brandContext=brandContextParam : console.log('Generating experience ' + brandContextParam);

$(document).ready(function() {
  $('.cswidget').attr('data-action', 'csWidgetOpen')
})

</script>
 
<template>
  <logoBar :brandExperience="brandContext" />
  <hero :brandExperience="brandContext" /> 
  <widget :brandExperience="brandContext" />
  <section class="animation-wrapper">
    <twoColInteractive :brandExperience="brandContext" /> 
    <maininfo :brandExperience="brandContext" />
    <bubbles />
  </section>
  
</template>

<style>
body {
  margin: 0;
}
#app {
  max-width: 100%;
  overflow: hidden;
  position: relative;
  text-align: center;
}
.animation-wrapper {
  position: relative;
}
</style>
